import { useEffect, type RefObject } from 'react';

/** Sync the HTML `inert` attribute without changing visual disabled styles. */
export function useInert(ref: RefObject<HTMLElement | null>, inert: boolean): void {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.toggleAttribute('inert', inert);
  }, [ref, inert]);
}
